<template>
  <div class="blocked_logs_page">
    <h1>充值来源数据报表</h1>
    <div class="user-options clearfix">
      <el-select
        style="width: 160px"
        v-model="curChannel.selectValue"
        placeholder
      >
        <el-option
          v-for="(item, itemIndex) in channels"
          v-bind:key="itemIndex"
          :label="item.label"
          :value="item.value"
        ></el-option>
      </el-select>
      <el-select
        style="width: 160px"
        v-model="language"
        placeholder
      >
        <el-option
            v-for="(item, itemIndex) in languageList"
            v-bind:key="itemIndex + 199"
            :label="item.language"
            :value="item.langCode"
          ></el-option>
      </el-select>
       <el-select
        style="width: 160px"
        v-model="country"
        placeholder
      >
        <el-option
            v-for="(item, itemIndex) in countryList"
            v-bind:key="itemIndex + 99"
            :label="item.country"
            :value="item.countryCode"
          ></el-option>
      </el-select>
     
      <el-date-picker
          v-model="platformData"
          type="daterange"
          align="right"
          unlink-panels
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          :picker-options="retainedOptions"
          value-format="yyyy-MM-dd"
        >
        </el-date-picker>
      <el-button type="primary" @click="get_list" :loading="login1">查询</el-button>
      <!-- <el-button type="primary" @click="downloadReport">下载</el-button> -->
    </div>
    <el-table
        :data="tableList"
        style="width: 100%"
        border
        v-loading="login1"
      >
      <el-table-column align="center" prop="date" label="日期" width="150" sortable>
        </el-table-column>
        <el-table-column align="center" prop="discoverCount" label="Discover次数" width="150" sortable>
        </el-table-column>
        <el-table-column align="center" prop="discoverMoney" label="Discover金额" width="150" sortable>
        </el-table-column>
        <el-table-column align="center" prop="discoverPeople" label="Discover人数" width="150" sortable>
        </el-table-column>
        <el-table-column align="center" prop="popularCount" label="Popular次数"  sortable width="160">
        </el-table-column>
        <el-table-column align="center" prop="popularMoney" label="Popular金额"  sortable width="160">
        </el-table-column>
        <el-table-column align="center" prop="popularPeople" label="Popular人数"  sortable width="160">
        </el-table-column>
        <el-table-column align="center" prop="nearbyCount" label="Nearby次数"  sortable width="160">
        </el-table-column>
        <el-table-column align="center" prop="nearbyMoney" label="Nearby金额"  sortable width="160">
        </el-table-column>
        <el-table-column align="center" prop="nearbyPeople" label="Nearby人数"  sortable width="160">
        </el-table-column>
        <el-table-column align="center" prop="followCount" label="Follow次数" width="150" sortable>
        </el-table-column>
        <el-table-column align="center" prop="followMoney" label="Follow金额" width="150" sortable>
        </el-table-column>
        <el-table-column align="center" prop="followPeople" label="Follow人数"  sortable width="140">
        </el-table-column>
        <el-table-column align="center" prop="dataPageCount" label="资料页次数" width="150" sortable>
        </el-table-column>
        <el-table-column align="center" prop="dataPageMoney" label="资料页金额" width="150" sortable>
        </el-table-column>
        <el-table-column align="center" prop="dataPagePeople" label="资料页人数" width="150" sortable>
        </el-table-column>
        <el-table-column align="center" prop="videoPageCount" label="视频资料页次数"  sortable width="160">
        </el-table-column>
        <el-table-column align="center" prop="videoPageMoney" label="视频资料页金额"  sortable width="160">
        </el-table-column>
        <el-table-column align="center" prop="videoPagePeople" label="视频资料页人数"  sortable width="160">
        </el-table-column>
        <el-table-column align="center" prop="matchPageCount" label="匹配首页次数"  sortable width="160">
        </el-table-column>
        <el-table-column align="center" prop="matchPageMoney" label="匹配首页金额"  sortable width="160">
        </el-table-column>
        <el-table-column align="center" prop="matchPagePeople" label="匹配首页人数"  sortable width="160">
        </el-table-column>
         <el-table-column align="center" prop="matchingCount" label="匹配中次数"  sortable width="160">
        </el-table-column>
        <el-table-column align="center" prop="matchingMoney" label="匹配中金额"  sortable width="160">
        </el-table-column>
        <el-table-column align="center" prop="matchingPeople" label="匹配中人数"  sortable width="160">
        </el-table-column>
        <el-table-column align="center" prop="msgPageCount" label="消息页次数"  sortable width="160">
        </el-table-column>
        <el-table-column align="center" prop="msgPageMoney" label="消息页金额"  sortable width="160">
        </el-table-column>
        <el-table-column align="center" prop="msgPagePeople" label="消息页人数"  sortable width="160">
        </el-table-column>
        <el-table-column align="center" prop="msgFrameCount" label="消息对话框次数"  sortable width="160">
        </el-table-column>
        <el-table-column align="center" prop="msgFrameMoney" label="消息对话框金额"  sortable width="160">
        </el-table-column>
        <el-table-column align="center" prop="msgFramePeople" label="消息对话框人数"  sortable width="160">
        </el-table-column>
        <el-table-column align="center" prop="commonCallCount" label="普通通话次数" width="150"  sortable>
        </el-table-column>
        <el-table-column align="center" prop="commonCallMoney" label="普通通话金额" width="150"  sortable>
        </el-table-column>
        <el-table-column align="center" prop="commonCallPeople" label="普通通话人数" width="150"  sortable>
        </el-table-column>
        <el-table-column align="center" prop="matchCallCount" label="匹配通话次数"  sortable width="150">
        </el-table-column>
        <el-table-column align="center" prop="matchCallMoney" label="匹配通话金额"  sortable width="150">
        </el-table-column>
        <el-table-column align="center" prop="matchCallPeople" label="匹配通话人数"  sortable width="150">
        </el-table-column>
        <el-table-column align="center" prop="personalCenterCount" label="个人中心次数"  sortable width="160">
        </el-table-column>
        <el-table-column align="center" prop="personalCenterMoney" label="个人中心金额"  sortable width="160">
        </el-table-column>
        <el-table-column align="center" prop="personalCenterPeople" label="个人中心人数"  sortable width="160">
        </el-table-column>
        <el-table-column align="center" prop="walletCount" label="钱包次数"  sortable width="160">
        </el-table-column>
        <el-table-column align="center" prop="walletMoney" label="钱包金额"  sortable width="160">
        </el-table-column>
        <el-table-column align="center" prop="walletPeople" label="钱包人数"  sortable width="160">
        </el-table-column>
      </el-table>
     <el-row class="user-options">
      <el-pagination
        :current-page.sync="page"
        layout="total, prev, pager, next"
        background
        @current-change="handleCurrentChange"
        :total="total"
        :page-size="50"
        class="pagination"
      ></el-pagination>
     </el-row>
  </div>
</template>

<script>
import { datainfor } from '@/utils/formdata.js'
import { getCountry, getLanguage } from '@/utils/normalApi.js'
export default {
  data() {
    return {
      login1: false,
      curChannel: {
        selectValue: 'total',
        content: ''
      },
      channels: this.$store.state.channels,
      platformData: [datainfor(1), datainfor(1)],
      retainedOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now()
        }
      },
      tableList: [],
      loading: true,
      page: 1,
      total: 0,
      language: 'total',
      languageList: '',
      country: 'total',
      countryList: ''
    }
  },
  beforeCreate() {},
  created() {
    this.languages()
    this.getCountry_()
    this.get_list()
  },
  mounted() {},
  computed: {
    username() {
      return this.$store.getters.username
    },
    userLevel() {
      return this.$store.getters.userLevel
    },
    token() {
      return this.$store.getters.token
    }
  },
  watch: {},
  methods: {
    async languages() {
      const res = await getLanguage()
      if (res !== null) {
        this.languageList = res
      }
    },
    async getCountry_() {
      this.login1 = true
      const res = await getCountry()
      if (res !== null) {
        this.countryList = res.countryList
      }
    },
    // 分页
    handleCurrentChange() {
      this.get_list()
    },
    async get_list() {
      const { data: res } = await this.$axios({
        method: 'get',
        url: this.$store.getters.path.report_rechargeSource,
        withCredentials: true,
        params: {
          username: this.$store.getters.username,
          token: this.$store.getters.token,
          start: this.platformData[0],
          end: this.platformData[1],
          channel: this.curChannel.selectValue,
          country: this.country,
          language: this.language
        }
      })
      if (res !== null) {
        this.login1 = false
        this.tableList = res.data.data
        this.total = res.data.total
      }
    }
  }
}
</script>


<style lang="stylus" scoped>

.blocked_logs_page {
  margin-left: 20px;
  margin-top: 20px;

  h1 {
    font-size: 28px;
    font-weight: bold;
  }

  .user-options {
    margin-top: 40px;

    button {
      margin-left: 30px;
    }
  }

  .display-type {
    margin-top: 20px;
  }
}
</style>
